<section class="checkout position-relative pt-3">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="contactForm">
          <div class="row">
            <div class="col-md-6">
              <label>Nombre*</label>
              <input class="mb-2" formControlName="firstName" type="text" name="firstName" value="" placeholder="Nombre">
              <div
                *ngIf="contactForm.controls['firstName'].errors && !contactForm.controls['firstName'].pristine && contactForm.controls['firstName'].untouched == false">
                <div *ngIf="contactForm.controls['firstName'].errors.required " class="text-danger error"> El nombre es obligatorio
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Primer Apellido*</label>
              <input class="mb-2" formControlName="lastName" type="text" name="lastName" value="" placeholder="Primer apellido">
              <div
                *ngIf="contactForm.controls['lastName'].errors && !contactForm.controls['lastName'].pristine && contactForm.controls['lastName'].untouched == false">
                <div *ngIf="contactForm.controls['lastName'].errors.required " class="text-danger error"> El apellido es obligatorio
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Segundo Apellido</label>
              <input class="mb-2" formControlName="secondLastName" type="text" name="secondLastName" value="" placeholder="Segundo apellido">
            </div>
            <div class="col-md-6">
              <label>Carné de identidad*</label>
              <input class="mb-2" formControlName="identity" type="text" name="identity" value="" placeholder="Carné de identidad">
              <div
                *ngIf="contactForm.controls['identity'].errors && !contactForm.controls['identity'].pristine && contactForm.controls['identity'].untouched == false">
                <div *ngIf="contactForm.controls['identity'].errors.required " class="text-danger error"> El carné de identidad es obligatorio
                </div>
                <div *ngIf="contactForm.controls['identity'].errors.invalidIdentity || contactForm.controls['identity'].errors.invalidInt" class="text-danger error under"> El
                  carné de identidad es inválido</div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Teléfono*</label>
              <input class="mb-2" formControlName="phone" type="text" name="phone" value="" placeholder="Teléfono">
              <div
                *ngIf="contactForm.controls['phone'].errors && !contactForm.controls['phone'].pristine && contactForm.controls['phone'].untouched == false">
                <div *ngIf="contactForm.controls['phone'].errors.required " class="text-danger error"> El teléfono es obligatorio
                </div>
                <div *ngIf="contactForm.controls['phone'].errors.invalidNumber" class="text-danger error under"> El
                  teléfono es inválido</div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Nombre o número de la calle*</label>
              <input class="mb-2" formControlName="addressLine1" type="text" name="address1" value="" placeholder="Nombre o número de la calle">
              <div
                *ngIf="contactForm.controls['addressLine1'].errors && !contactForm.controls['addressLine1'].pristine && contactForm.controls['addressLine1'].untouched == false">
                <div *ngIf="contactForm.controls['addressLine1'].errors.required " class="text-danger error"> La dirección es obligatoria
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Apto, edificio, piso (opcional)</label>
              <input class="mb-2" formControlName="addressLine2" type="text" name="address2" value=""
                     placeholder="Apto, edificio, piso">
            </div>

            <div class="col-md-6 locations">
              <label>Provincia/Municipio*</label>
              <app-dropdown-treeview-select [class]="'add-contact-location'" [items]="locations"
                                            [(value)]="item.code" (valueChange)="onChange($event)">
              </app-dropdown-treeview-select>
              <div
                *ngIf="onSaveEvent && item.code == 0">
                <div class="text-danger error under"> El
                  municipio es obligatorio</div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Localidad</label>
              <input class="mb-2" formControlName="town" type="text" name="location" value="" placeholder="Localidad">
            </div>
            <div class="col-md-6">
              <input class="h-auto" id="add-contact" type="checkbox" formControlName="isDefault" name="default" />
              <label class="ml-2" for="add-contact">Marcar como dirección preferida</label>
            </div>
            <div class="d-flex justify-content-end w-100">
              <button type="button" name="button" class="btn btn-primary mr-2" [disabled]="contactForm.invalid || contactForm.pristine" (click)="saveContact()">Guardar</button>
              <button type="button" name="button" class="btn btn-secondary bg-transparent text-secondary" (click)="showForm.emit({showForm: false, contact: null, action: ''})">Cancelar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
